import React from 'react';
import PropTypes from 'prop-types';
import { Item } from '../../components';

const SimpleListItem = ({ items }) =>
  <div className="col-xs-12">
    <ul className="glossary-list">
      {items.map((item, index) => <Item key={index} {...item} />)}
    </ul>
  </div>;

SimpleListItem.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      term: PropTypes.string.isRequired,
      letter: PropTypes.string.isRequired,
      definition: PropTypes.string.isRequired,
      subitems: PropTypes.object
    })
  ).isRequired
};

export default SimpleListItem;



// WEBPACK FOOTER //
// ./src/pages/identity-glossary/components/SimpleListItem/SimpleListItem.js